import { Minus, Plus } from "lucide-react";

export default function QuantityInput({ value, onChange, min = 0 }) {
  return (
    <div className="inline-flex items-center rounded-full border border-border bg-white">
      <button
        type="button"
        aria-label="Decrease quantity"
        onClick={() => onChange(Math.max(min, Number(value) - 1))}
        className="p-2 focus:outline-none focus:ring-2 focus:ring-ring"
      >
        <Minus className="size-4" />
      </button>

      <input
        type="number"
        min={min}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-12 bg-transparent text-center text-sm font-semibold outline-none"
        aria-label="Quantity"
      />

      <button
        type="button"
        aria-label="Increase quantity"
        onClick={() => onChange(Number(value) + 1)}
        className="p-2 focus:outline-none focus:ring-2 focus:ring-ring"
      >
        <Plus className="size-4" />
      </button>
    </div>
  );
}